class Minicart extends HTMLElement {
  constructor() {
    super();
    this.onCartUpdate = this.onCartUpdate.bind(this);
    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
  }

  connectedCallback() {
    document.addEventListener('cart:update', this.onCartUpdate);
    document.addEventListener('minicart:open', this.openDrawer);
    const closeButton = this.querySelector('.minicart__close-button-wrapper');
    if (closeButton) closeButton.addEventListener('click', this.closeDrawer);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this.onCartUpdate);
    document.removeEventListener('minicart:open', this.openDrawer);
    const closeButton = this.querySelector('.minicart__close-button-wrapper');
    if (closeButton) closeButton.removeEventListener('click', this.closeDrawer);
  }

  async onCartUpdate() {
    this.render();
  }

  async openDrawer() {
    await this.render();
    // Espera a que el nuevo <mini-cart> esté en el DOM
    const newMiniCart = document.querySelector('mini-cart');
    if (newMiniCart) {
      const drawer = newMiniCart.closest('theme-drawer');
      if (drawer) drawer.open();
    }
  }

  closeDrawer() {
    const drawer = this.closest('theme-drawer');
    drawer.close();
  }

  async render() {
    const sectionId = this.dataset.sectionId;

    try {
      const response = await fetch(`${window.location.origin}/?sections=${sectionId}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      if (data && data[sectionId]) {
        // Find the section container by ID
        const sectionContainer = document.getElementById(`shopify-section-${sectionId}`);
        if (!sectionContainer) return;

        // Replace the entire section's HTML
        sectionContainer.innerHTML = data[sectionId];
      }
    } catch (error) {
      console.error('Error fetching and updating section:', error);
    }
  }
}

customElements.define('mini-cart', Minicart);